/**
 * [权限设置]
 * @author: Fu Xiaochun
 * @date: 2021-09-14 
 */
import http from '@/assets/api/http';

// 获取角色权限菜单列表
export async function getListMenuByRole(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.listMenuByRole',params,'POST');
}

// 保存角色菜单权限
export async function saveRoleMenuList(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.savePlatRoleMenu',params,'POST');
}

// 获取智能调度系统数据权限
export async function getSmartDataPermissions(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.AcDataAuthorityInfoMisService.listRoleDataAuthorityInfo',params,'POST', 20000);
}

// 保存智能调度系统数据权限
export async function saveSmartDataPermissions(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.AcDataAuthorityInfoMisService.updateRoleDataAuthorityInfo',params,'POST', 20000);
}